import * as vp from 'vopay';
import { Box, Select, TextField, DateRangePicker } from 'vopay';
import { FunctionComponent, useState } from 'react';
import styles from './ApprovalInbox.module.scss';
import { useTranslation } from 'react-i18next';
import { Button } from 'UI';

type ApprovalInboxSearchParams = {
  currency: string;
  searchTerm: string;
  timeRange: [vp.Timestamp, vp.Timestamp];
};

type SearchFormProps = {
  currency: string;
  searchTerm: string;
  initialTimeRange: [vp.Timestamp, vp.Timestamp];
  hasInvalidEndDate?: boolean;
  shouldShowEndDateError?: boolean;
  setShouldShowEndDateError?: (event: boolean) => void;
  search: (searchParams: ApprovalInboxSearchParams) => void;
};

type FC = FunctionComponent<SearchFormProps>;

const ApprovalInboxSearchForm: FC = ({
  currency,
  searchTerm,
  hasInvalidEndDate,
  shouldShowEndDateError,
  setShouldShowEndDateError,
  initialTimeRange,
  search,
}: SearchFormProps) => {
  const { t } = useTranslation('translations', { keyPrefix: 'TransactionApproval.Inbox.SearchForm' });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });

  const [currentCurrency, setCurrentCurrency] = useState<string>(currency);
  const [currentSearchTerm, setCurrentSearchTerm] = useState<string>(searchTerm);
  const [timeRange, setTimeRange] = useState<[vp.Timestamp, vp.Timestamp]>(initialTimeRange);

  const currencyOptions = [
    { value: 'CAD', label: 'CAD' },
    { value: 'USD', label: 'USD' },
  ];

  return (
    <Box flx="row" gap="sm" wrap="wrap">
      <div className={styles.datePickerContainer}>
        <DateRangePicker
          onChange={(range) => {
            setTimeRange(range);
          }}
          initialTime={initialTimeRange}
          hasInvalidEndDate={hasInvalidEndDate}
          shouldShowEndDateError={shouldShowEndDateError}
          setShouldShowEndDateError={setShouldShowEndDateError}
          triggerVariant="outlineShadow"
        />
      </div>
      <Box width="200px">
        <Select
          version="2"
          placeholder={t('currencyPlaceholder')}
          options={currencyOptions}
          name="currency"
          value={currentCurrency}
          onBlur={() => {}}
          onChange={(e) => {
            setCurrentCurrency(e.target.value);
          }}
        />
      </Box>

      <Box maxwidth="180px">
        <TextField
          key="AccountSearchKeyword"
          name="AccountSearchKeyword"
          placeholder={t('keywordPlaceholder')}
          value={currentSearchTerm}
          onBlur={() => {}}
          onChange={(e) => {
            setCurrentSearchTerm(e.target.value);
          }}
          variant="outlineShadow"
        />
      </Box>

      <Button
        id="search-schedule-transactions"
        size="small"
        colorScheme="primary"
        onClick={() => {
          search({
            currency: currentCurrency,
            searchTerm: currentSearchTerm,
            timeRange,
          });
        }}
      >
        {tGlobal('Buttons.search')}
      </Button>
    </Box>
  );
};

export default ApprovalInboxSearchForm;
